export default __webpack_public_path__ + "static/media/card-image-silver.7f3ca790.png";